import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import DoubleRightIcon from "../../atoms/icons/double-angle-right";
import CustomStoryCard9 from "../../molecules/custom-story-card9";
import CustomStoryCard10 from "../../molecules/custom-story-card10";

import "./explainer.m.css";

const Explainer = ({ collection, publisherName, pageType }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const stories = collection.items
    .filter((item) => item.type === "story")
    .slice(0, document.body.clientWidth < 768 ? 3 : 4)
    .map((item) => item.story);

  if (!stories.length) {
    return null;
  }

  const [firstStory, ...remainingStories] = stories;

  return (
    <div styleName="wrapper" className="container" id={collection.slug}>
      <div styleName="collection-name">
        <Link href="/explainers">
          <Headline text={collection.name || ""} headerType={6} />
        </Link>
        {pageType === "home-page" && (
          <Link href="/explainers">
            <DoubleRightIcon />
          </Link>
        )}
      </div>
      <div styleName="content">
        <CustomStoryCard10 publisherName={publisherName} story={firstStory} />
        <div styleName="stories">
          {remainingStories.map((story, index) => (
            <CustomStoryCard9 key={index} story={story} />
          ))}
        </div>
      </div>
    </div>
  );
};

Explainer.propTypes = {
  collection: object.isRequired,
  publisherName: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  pageType: get(state, ["qt", "pageType"], null),
});

export default connect(mapStateToProps, null)(Explainer);
